// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'semantic-ui-react';

class DropdownCylinderQtd extends Component {
    constructor(props) {
        super(props);
        this.state = {
            options: this.initOptions(props),
        };
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.maxValue !== nextProps.maxValue) {
            this.setState({ options: this.initOptions(nextProps.maxValue) });
        }
    }

    initOptions(props) {
        let options = [];
        for (let i = props.maxValue; i >= props.minValue; i--) {
            options.push({ key: i, text: i, value: i });
        }
        return options;
    }

    onChange = (e, { value }) => {
        const { onChange } = this.props;
        if (onChange) {
            onChange(value);
        }
    };

    render() {
        const { options } = this.state;
        return <Dropdown options={options} value={this.props.value} onChange={this.onChange} style={{ marginLeft: '4px' }} selection compact />;
    }
}

DropdownCylinderQtd.propTypes = {
    maxValue: PropTypes.number,
    value: PropTypes.number,
    onChange: PropTypes.func,
};

export default DropdownCylinderQtd;
